import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, timer } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { ApiEndPoint } from 'src/configurations/constants';

@Injectable({
  providedIn: 'root',
})
export class UserSettingService {
  httpOptions;
  httpBoday = '';
  whoCanSendLetterbyuid;
  pageIndex = 1;
  pageSize = 10;
  ValueForChangeProfilePic: any;
  public ValueForChangeProfilePicGlobally: BehaviorSubject<String> = new BehaviorSubject<String>(`ok`);
  constructor(private http: HttpClient) { }

  getValueOfPagination(pageIndex, pageSize) {
    this.pageIndex = pageIndex;
    this.pageSize = pageSize;
  }

  getAllUsers() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    // `/users?recordsPerPage=10&page=1`
    return this.http
      .get<any>(
        ApiEndPoint.Users.logins + `?recordsPerPage=${this.pageSize}&page=${this.pageIndex}`,
        this.httpOptions
      )
      .pipe(
        tap(
          (user) => { },
          (err) => {
            console.log(err);
          }
        )
      );
  }

  getAllHiringManagers() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.HiringManagers.all, this.httpOptions);
  }

  getRecruiters() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.Recruiters.all, this.httpOptions);
  }

  createUser(userData): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post(ApiEndPoint.Users.logins, userData, this.httpOptions).pipe(
      tap(
        (user) => {
          console.log(user);
        },
        (err) => {
          console.log(err);
        }
      )
    );
  }

  updateUser(userData, uid): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put(ApiEndPoint.Users.logins + `/${uid}`, userData, this.httpOptions);
  }

  updateUserAvatar(userData, uid): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post(ApiEndPoint.Users.avatar, userData, this.httpOptions);
  }

  deletePowerUser(row): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.Users.logins + `/${row.uid}/delete`, { "email": row.email }, this.httpOptions);
  }

  getRecruitTeamMember() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get(ApiEndPoint.Users.recruitTeams, this.httpOptions);
  }

  updateRTMember(updatedMember) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': token,
        'language-iso': 'en'
      })
    };

    return this.http.put(ApiEndPoint.Users.recruitTeam, updatedMember, this.httpOptions);
  }

  createRTMember(newMember) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': token,
        'language-iso': 'en'
      })
    };

    return this.http.post(ApiEndPoint.Users.recruitTeam, newMember, this.httpOptions);
  }

  deleteRecruitTeamMember(RTID): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(
      ApiEndPoint.Users.recruitTeam + `/delete`, 
      { "recruiter_id": RTID }, 
      this.httpOptions);
  }

  getMyProfile_UserPreferenceData() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get(ApiEndPoint.Users.preference, this.httpOptions);
  }

  UpdateCandidateProfile(imgValue) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post(ApiEndPoint.Users.avatar, imgValue, this.httpOptions);
  }

  updateUserPreference(userPreferenceBody) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put(ApiEndPoint.Users.preference, userPreferenceBody, this.httpOptions);
  }

  resetPassword(resetPasswordBody) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post(ApiEndPoint.Users.password, resetPasswordBody, this.httpOptions);
  }

  // change Profile Image Globally
  getProfileDataAfterChange() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get(ApiEndPoint.Users.details, this.httpOptions);
  }

  getUserNotification() {
    const token = localStorage.getItem('token');
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'authorization': token,
      'language-iso': 'en'
    };

    return this.http.get<any>(ApiEndPoint.Users.notification, { headers });
  }

  updateNotification(notificationBody): Observable<any> {

    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'authorization': token,
        'language-iso': 'en',
      }),
    };

    return this.http.put(
      ApiEndPoint.Users.notification, 
      notificationBody, 
      this.httpOptions);
  }

  isEmailExist(request): Observable<any> {
    const token = localStorage.getItem('token');
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: token,
        'language-iso': 'en'
      })
    };

    // debounce
    return timer(1000)
      .pipe(
        switchMap(() => {
          return this.http.post<any>(ApiEndPoint.Users.logins + '/exist', 
                                    request,
                                    httpOptions); 
        })
      );
  }

  isRecruiterExist(request): Observable<any> {
    const token = localStorage.getItem('token');
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: token,
        'language-iso': 'en'
      })
    };

    // debounce
    return timer(1000)
      .pipe(
        switchMap(() => {
          return this.http.post<any>(ApiEndPoint.Users.recruitTeam + "/exist", 
                                    request,
                                    httpOptions); 
        })
      );
  }

  isHandleExist(request): Observable<any> {
    const token = localStorage.getItem('token');

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: 'application/json',
        authorization: token,
        'language-iso': 'en'
      })
    };

    // debounce
    return timer(1000)
      .pipe(
        switchMap(() => {
          return this.http.post<any>(ApiEndPoint.Users.logins + "/handleduplicated", 
                                    request,
                                    httpOptions); 
        })
      );
  }

  updateCalendarSetting(data) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put(ApiEndPoint.Schedule.range, data, this.httpOptions);
  }

  getCalendarSetting() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get(ApiEndPoint.Schedule.range, this.httpOptions);
  }
}
